import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [providers, setProviders] = useState<any>({});

  React.useEffect(() => {
    fetch("/api/auth/providers").then(r => r.json()).then(setProviders).catch(() => {});
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
    } catch (err: any) {
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4"
         style={{ background: "radial-gradient(ellipse at top, #1a1d2e 0%, #0f1117 70%)" }}>
      <div className="text-center mb-10">
        <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-500 to-purple-500 flex items-center justify-center text-3xl font-bold text-white mx-auto mb-4 shadow-lg shadow-blue-500/30">
          V
        </div>
        <h1 className="text-3xl font-bold">Dakok <span className="text-blue-400">Vista</span></h1>
        <p className="text-gray-400 mt-1">Cost Analytics Portal</p>
      </div>

      {/* Sign In (Cognito) */}
      {providers.cognito && (
        <div className="w-full max-w-sm mb-6">
          <a
            href={providers.cognito.loginUrl}
            className="w-full block text-center py-3 rounded-lg bg-gradient-to-r from-blue-500 to-purple-500 text-white font-semibold hover:-translate-y-0.5 hover:shadow-lg hover:shadow-blue-500/40 transition-all"
          >
            Sign In
          </a>
        </div>
      )}

      <div className="mt-12 flex items-center gap-2 text-gray-500 text-xs">
        <span>Powered by</span>
        <img
          src="https://d1.awsstatic.com/logos/aws-logo-lockups/poweredbyaws/PB_AWS_logo_RGB_stacked_REV_SQ.91cd4af40773cbfbd15577a3c2b8a346fe3e8fa2.png"
          alt="AWS"
          className="h-6 opacity-50"
        />
      </div>
    </div>
  );
}
